import React, { useState, useEffect } from "react";
// import './faqs.css'
import "bootstrap/dist/css/bootstrap.min.css";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

import Offcanvas from "react-bootstrap/Offcanvas";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  "&:not(:last-child)": {
    borderBottom: 0
  },
  "&:before": {
    display: "none"
  }
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "rgba(215,221,224,1)" : "rgba(215,221,224,1)",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)"
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: 0
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "#00aff1"
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2)
}));

const FaqsDinamic = ({ vistaProducto, producto }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [expanded, setExpanded] = useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const [newTitle, setNewTitle] = useState("");
  const { title } = producto;

  const changeUrl = (title) => {
    const newTitulo = encodeURI(title?.replaceAll(" ", "-")).toLowerCase();
    setNewTitle(newTitulo);
  };

  useEffect(() => {
    changeUrl(title);
  }, []);

  let descargasVisibles;

  descargasVisibles = producto.filename?.filter(
    (item) => item.state === true && item.deleted !== true
  );

  return (
    <>
      {vistaProducto ? (
        <button
          onClick={handleShow}
          className="settings_button-border button-b-primary_2 button_faqs_product"
        >
          FAQs <ArrowForwardIcon />
        </button>
      ) : (
        <button
          onClick={handleShow}
          className={`faqs__productos-list ${producto.faqsEnabled ? "" : "d-none"}`}
        >
          {producto.title}
          <ArrowForwardIcon />
        </button>
      )}

      <div className="container faqs__wrapper-faqs ">
        <Offcanvas
          show={show}
          onHide={handleClose}
          placement="end"
          className="faqs__productos-offcanvas"
        >
          <Offcanvas.Header className="display-botton-faqs">
            <button onClick={handleClose} className="bottom-back">
              <ArrowBackIcon />
            </button>
            <img
              className="img-faqs-block"
              src={producto.imageLogo ? producto.imageLogoColor[0]?.url : producto.imageLogoColor}
              alt={producto.imageLogo ? producto.imageLogoColor[0]?.alt : producto.title}
              loading="lazy"
            />
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="col-12 col-lg-6">
              <article className="categories faqs__offcanvas">
                {producto.faqs
                  ? producto.faqs.map((faq, index) => (
                      <div key={index}>
                        <Accordion
                          expanded={expanded === `panel${index}`}
                          onChange={handleChange(`panel${index}`)}
                        >
                          <AccordionSummary
                            aria-controls={`panel${index}d-content`}
                            id={`panel${index}d-header`}
                            className="faqs-offcanvas"
                          >
                            <Typography>{faq.question}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography
                              className="productFaqs-tiny-editor"
                              dangerouslySetInnerHTML={{
                                __html: faq.answer
                              }}
                            ></Typography>
                          </AccordionDetails>
                        </Accordion>
                        <hr />
                      </div>
                    ))
                  : ""}
              </article>
              <div role="presentation" className="col-12 pt-3 column-faqs">
                <div className={`width-50 ${descargasVisibles?.length === 0 ? "d-none" : ""}`}>
                  <h3>Descargas</h3>

                  <ul className="settings__lista-descargas">
                    {producto?.filename?.map(
                      (item, index) =>
                        item.state === true &&
                        item.deleted === false && (
                          <li key={index}>
                            <DownloadIcon />
                            <a
                              href={item?.url}
                              Target="_blank"
                              title={`Descargar ${item.filename}`}
                            >
                              {item?.title}
                            </a>
                          </li>
                        )
                    )}
                  </ul>
                </div>
                {vistaProducto ? (
                  <button className="settings_button-pleno bg-p-primary_2 d-block">
                    <a href="/preguntas-frecuentes" className="d-flex align-items-center">
                      preguntas frecuentes <ArrowForwardIcon />
                    </a>
                  </button>
                ) : (
                  <button className="settings_button-pleno bg-p-primary_2 d-block">
                    <a href={`/producto/${newTitle}`}>
                      Ir al producto <ArrowForwardIcon />
                    </a>
                  </button>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-6">
              {producto.faqs
                ? producto.faqs.map((faq, index) => {
                    if (faq.video) {
                      <h3 className="video text-start">Videos</h3>;

                      const videoId = faq.video.replace("https://www.youtube.com/embed/", "");

                      return (
                        <article key={index} className="faqs__article-video">
                          <div className="first">
                            <iframe
                              className="pb-5"
                              srcDoc={`
                              <style>
                                  body, .full {
                                      width: 100%;
                                      height: 100%;
                                      margin: 0;
                                      position: absolute;
                                      display: flex;
                                      justify-content: center;
                                      object-fit: cover;
                                  }
                              </style>
                              <a
                                  href='${faq.video}?autoplay=1'
                                  class='full'
                              >
                                  <img
                                      src='http://img.youtube.com/vi/${videoId}/0.jpg'
                                      class='full'
                                      loading="lazy"
                                  />
                                  <svg
                                      version='1.1'
                                      viewBox='0 0 68 48'
                                      width='68px'
                                      style='position: relative;'
                                  >
                                      <path d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' fill='#f00'></path>
                                      <path d='M 45,24 27,14 27,34' fill='#fff'></path>
                                  </svg>
                              </a>
                          `}
                              style={{ maxWidth: "640px", width: "100%", "aspect-ratio": "16/9" }}
                              allow="autoplay *; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              frameBorder="0"
                            ></iframe>
                          </div>
                        </article>
                      );
                    }
                  })
                : ""}
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default FaqsDinamic;
